import {
  Box,
  Grid,
  Typography,
  TextField,
  FormControl,
  Select,
  MenuItem,
  Button,
  FormHelperText,
  Checkbox,
  FormControlLabel,
  RadioGroup,
  Radio,
} from "@mui/material";
import { useState } from "react";
import {
  boardSubjectsMap,
  schoolBoards,
} from "./Fixed Data/MappingsFor9thand10th";
import apiClient from "../../../utils/apiClient";
import { INDIAN_STATES } from "./Fixed Data/indianStates";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const SchoolingStep910 = ({ data, setData, handleNext, handleBack }) => {
  const navigate = useNavigate();
  const [isSubmitting, setSubmitting] = useState();
  const checkCategory = async () => {
    setSubmitting(true);
    const response = await apiClient.get("/counselling/initial-info/category");
    if (response.data.success) {
      const category = response.data.data.category;
      if (["Class 10th", "Class 11th", "Class 12th"].includes(category)) {
        navigate("/workshop-info");
      } else {
        navigate("/areaType-info");
      }
    }
    setSubmitting(false);
  };

  useEffect(() => {
    const fetchSchoolingData = async () => {
      try {
        const res = await apiClient.get("/counselling/schooling-9-10");
        console.log(res);
        if (!res.data?.data) return;

        const apiData = res.data.data;

        setData((prev) => ({
          ...prev,

          // 🔹 School-level fields
          school_name: apiData.school_name || "",
          school_board: apiData.school_board || "",
          city: apiData.city || "",
          years: apiData.years || "",
          stream: apiData.stream || "",
          grading: apiData.grading || "",

          // 🔹 Class-wise data
          academics: {
            ...(prev.academics || {}),
            9: apiData.class_9 || {},
            10: apiData.class_10 || {},
          },
        }));

        // 👉 If class 10 already exists, open class 10 view
        if (apiData.class_10 && Object.keys(apiData.class_10).length > 0) {
          setShowClass10(true);
        }
      } catch (err) {
        console.error("Error fetching schooling data", err);
      }
    };

    fetchSchoolingData();
  }, []);

  useEffect(() => {
    const class9Subjects = getClassData("9").subjects || [];
    const class10Subjects = getClassData("10").subjects || [];

    if (
      class9Subjects.length > 0 &&
      class9Subjects.length === class10Subjects.length &&
      class9Subjects.every((s) => class10Subjects.includes(s))
    ) {
      setSameSubjects(true);
    }
  }, [data.academics]);

  const [showClass10, setShowClass10] = useState(false);
  const [sameSubjects, setSameSubjects] = useState(false);

  // Local error state
  const [errors, setErrors] = useState({});
  const gradingOptions = ["Percentage", "CGPA (10 Scale)", "Grades"];
  const subjectsList = boardSubjectsMap[data.school_board] || [];

  const getClassData = (cls) => data?.academics?.[cls] || {};

  const setClassData = (cls, updated) => {
    setData({
      ...data,
      academics: {
        ...(data.academics || {}),
        [cls]: {
          ...(data.academics?.[cls] || {}),
          ...updated,
        },
      },
    });
  };

  const handleNextClick = async (data) => {
    if (!validate()) {
      alert("Please fill the data completely");
    } else {
      await apiClient.post("/counselling/schooling-9-10", data);
      handleNext();
    }
  };

  const uiFieldStyles = {
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#ffffff",
      borderRadius: "6px",
      "& fieldset": { borderColor: "#c9c9c9" },
      "&:hover fieldset": { borderColor: "#9d9d9d" },
      "&.Mui-focused fieldset": { borderColor: "#000" },
    },
    "& .MuiInputLabel-root": { color: "#444" },
    "& .MuiFormHelperText-root": { color: "#d32f2f" },
  };

  // Toggle subjects
  const toggleSubject = (cls, subject) => {
    let updated = [...(getClassData(cls).subjects || [])];

    if (updated.includes(subject)) {
      updated = updated.filter((s) => s !== subject);
    } else {
      updated.push(subject);
    }

    setClassData(cls, { subjects: updated });
  };

  const handleMarksChange = (cls, subject, value) => {
    setClassData(cls, {
      marks: {
        ...(getClassData(cls).marks || {}),
        [subject]: value,
      },
    });
  };

  const getMarksOptions = () => {
    if (data.grading === "Percentage") {
      return [
        "Not applicable",
        "30-40%",
        "40-50%",
        "50-60%",
        "60-70%",
        "70-80%",
        "80-90%",
        "Above 90%",
      ];
    }

    if (data.grading === "CGPA (10 Scale)") {
      return ["Not applicable", "1 - 3", "3 - 5", "5 - 7", "7 - 9", "9 - 10"];
    }

    if (data.grading === "Grades") {
      return ["Not applicable", "A+", "A", "B+", "B", "C", "D", "E"];
    }

    return ["Not applicable"];
  };

  // 🔥 VALIDATION FUNCTION
  const validate = () => {
    let temp = {};

    // ---------- Global validations ----------
    if (!data.school_name) temp.school_name = "School Name is required";
    if (!data.school_board) temp.school_board = "School Board is required";
    if (!data.city) temp.city = "City is required";
    if (!data.years) temp.years = "Years attended is required";
    if (!data.grading) temp.grading = "Grading option is required";

    // ---------- Class 9 validation ----------
    const class9 = data.academics?.["9"] || {};

    if (!class9.subjects || class9.subjects.length === 0) {
      temp.class9_subjects = "Select at least one subject for Class 9";
    }

    if (class9.subjects?.includes("Others") && !class9.other_subject) {
      temp.class9_other_subject = "Enter other subject for Class 9";
    }

    if (class9.subjects?.length > 0) {
      const missingMarks9 = class9.subjects.filter(
        (sub) => !class9.marks?.[sub],
      );

      if (missingMarks9.length > 0) {
        temp.class9_marks = `Select marks for Class 9: ${missingMarks9.join(
          ", ",
        )}`;
      }
    }

    // ---------- Class 10 validation ----------
    const class10 = data.academics?.["10"] || {};

    if (!class10.subjects || class10.subjects.length === 0) {
      temp.class10_subjects = "Select at least one subject for Class 10";
    }

    if (class10.subjects?.includes("Others") && !class10.other_subject) {
      temp.class10_other_subject = "Enter other subject for Class 10";
    }

    if (class10.subjects?.length > 0) {
      const missingMarks10 = class10.subjects.filter(
        (sub) => !class10.marks?.[sub],
      );

      if (missingMarks10.length > 0) {
        temp.class10_marks = `Select marks for Class 10: ${missingMarks10.join(
          ", ",
        )}`;
      }
    }

    setErrors(temp);
    return Object.keys(temp).length === 0;
  };

  return (
    <Box
      sx={{
        backgroundColor: "#d8f1f6",
        padding: { xs: 3, sm: 5 },
        borderRadius: "40px 40px 0 0",
        minHeight: "100vh",
      }}
    >
      <Typography
        sx={{
          fontSize: { xs: "22px", sm: "24px", md: "28px" },
          fontWeight: 600,
          mb: 1,
        }}
      >
        Schooling Information (9th + 10th)
      </Typography>
      {!showClass10 && (
        <>
          <Typography sx={{ fontSize: "18px", fontWeight: 600, mb: 4 }}>
            Class 9th
          </Typography>

          <Grid container spacing={3}>
            {/* School Name */}
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
                School Name*
              </Typography>
              <TextField
                fullWidth
                placeholder="School Name"
                sx={uiFieldStyles}
                value={data.school_name || ""}
                onChange={(e) =>
                  setData({ ...data, school_name: e.target.value })
                }
                error={!!errors.school_name}
                helperText={errors.school_name}
              />
            </Grid>

            {/* School Board */}
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
                School Board*
              </Typography>
              <FormControl
                fullWidth
                sx={uiFieldStyles}
                error={!!errors.school_board}
              >
                <Select
                  displayEmpty
                  value={data.school_board || ""}
                  onChange={(e) => {
                    setClassData("10", {
                      subjects: [],
                      marks: {},
                    });
                    setSameSubjects(false);
                    setClassData("9", {
                      school_board: e.target.value,
                      subjects: [],
                    });
                  }}
                >
                  <MenuItem value="" disabled>
                    Select Board
                  </MenuItem>
                  {schoolBoards.map((b) => (
                    <MenuItem key={b} value={b}>
                      {b}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>{errors.school_board}</FormHelperText>
              </FormControl>
            </Grid>

            {/* City */}
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
                Location / State*
              </Typography>

              <FormControl fullWidth sx={uiFieldStyles} error={!!errors.city}>
                <Select
                  displayEmpty
                  value={data.city || ""}
                  onChange={(e) => setData({ ...data, city: e.target.value })}
                >
                  <MenuItem value="" disabled>
                    Select state
                  </MenuItem>

                  {INDIAN_STATES.map((state) => (
                    <MenuItem key={state} value={state}>
                      {state}
                    </MenuItem>
                  ))}
                </Select>

                <FormHelperText>{errors.city}</FormHelperText>
              </FormControl>
            </Grid>

            {/* Years */}
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
                Years Attended*
              </Typography>
              <TextField
                fullWidth
                placeholder="Value"
                sx={uiFieldStyles}
                value={data.years || ""}
                onChange={(e) => setData({ ...data, years: e.target.value })}
                error={!!errors.years}
                helperText={errors.years}
              />
            </Grid>

            {/* Stream */}
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
                Stream (write NA if not applicable)*
              </Typography>
              <TextField
                fullWidth
                placeholder="Enter Stream"
                sx={uiFieldStyles}
                value={data.stream || ""}
                onChange={(e) => setData({ ...data, stream: e.target.value })}
                error={!!errors.stream}
                helperText={errors.stream}
              />
            </Grid>

            {/* Grading */}
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
                Choose Percentage/Grading options*
              </Typography>
              <FormControl
                fullWidth
                sx={uiFieldStyles}
                error={!!errors.grading}
              >
                <Select
                  displayEmpty
                  value={data.grading || ""}
                  onChange={(e) =>
                    setData({ ...data, grading: e.target.value })
                  }
                >
                  <MenuItem value="" disabled>
                    Choose option
                  </MenuItem>
                  {gradingOptions.map((g) => (
                    <MenuItem key={g} value={g}>
                      {g}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>{errors.grading}</FormHelperText>
              </FormControl>
            </Grid>

            {/* Subjects */}
            <Grid item xs={12}>
              <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 600 }}>
                Subjects*
              </Typography>

              <Box
                sx={{ background: "white", borderRadius: "10px", padding: 2 }}
              >
                {subjectsList.map((subject) => (
                  <FormControlLabel
                    key={subject}
                    control={
                      <Checkbox
                        checked={(getClassData("9").subjects || []).includes(
                          subject,
                        )}
                        onChange={() => toggleSubject("9", subject)}
                      />
                    }
                    label={subject}
                  />
                ))}
              </Box>
              {errors.class9_subjects && (
                <Typography sx={{ color: "#d32f2f", mt: 1 }}>
                  {errors.class9_subjects}
                </Typography>
              )}
            </Grid>

            {/* Other Subject */}
            {data.subjects?.includes("Others") && (
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  placeholder="Enter other subject"
                  sx={uiFieldStyles}
                  value={data.other_subject || ""}
                  onChange={(e) =>
                    setData({ ...data, other_subject: e.target.value })
                  }
                  error={!!errors.other_subject}
                  helperText={errors.other_subject}
                />
              </Grid>
            )}

            {/* Marks */}
            {subjectsList
              .filter((s) => getClassData("9").subjects?.includes(s))
              .map((subject) => (
                <Grid item xs={12} key={subject}>
                  <Typography sx={{ mb: 1, fontWeight: 600 }}>
                    Select Marks for {subject} (Class 9)
                  </Typography>

                  <RadioGroup
                    value={getClassData("9").marks?.[subject] || ""}
                    onChange={(e) =>
                      handleMarksChange("9", subject, e.target.value)
                    }
                  >
                    {getMarksOptions().map((m) => (
                      <FormControlLabel
                        key={m}
                        value={m}
                        control={<Radio />}
                        label={m}
                      />
                    ))}
                  </RadioGroup>
                </Grid>
              ))}

            {errors.class9_marks && (
              <Typography sx={{ color: "#d32f2f", mt: 1 }}>
                {errors.class9_marks}
              </Typography>
            )}
          </Grid>
        </>
      )}
      {!showClass10 && (
        <Box mt={4} display="flex" justifyContent="flex-start">
          <Button
            variant="contained"
            onClick={() => {
              // Optional: validate only Class 9 here
              setShowClass10(true);
            }}
          >
            Continue to Class 10th
          </Button>
        </Box>
      )}

      {showClass10 && (
        <>
          <Typography sx={{ fontSize: "18px", fontWeight: 600, mt: 6, mb: 4 }}>
            Class 10th
          </Typography>
          <Grid container spacing={3}>
            {/* School Name */}
            {/* <Grid item xs={12} md={6}>
          <Typography sx={{ mb: 1, fontWeight: 600 }}>School Name*</Typography>
          <TextField
            fullWidth
            sx={uiFieldStyles}
            value={getClassData("10").school_name || ""}
            onChange={(e) =>
              setClassData("10", { school_name: e.target.value })
            }
          />
        </Grid> */}

            {/* Board */}
            {/* <Grid item xs={12} md={6}>
          <Typography sx={{ mb: 1, fontWeight: 600 }}>School Board*</Typography>
          <FormControl fullWidth sx={uiFieldStyles}>
            <Select
              value={getClassData("10").school_board || ""}
              displayEmpty
              onChange={(e) =>
                setClassData("10", {
                  school_board: e.target.value,
                  subjects: [],
                })
              }
            >
              <MenuItem value="" disabled>
                Select Board
              </MenuItem>
              {schoolBoards.map((b) => (
                <MenuItem key={b} value={b}>
                  {b}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid> */}

            {/* Grading */}
            {/* <Grid item xs={12} md={6}>
          <Typography sx={{ mb: 1, fontWeight: 600 }}>
            Choose Percentage/Grading*
          </Typography>
          <FormControl fullWidth sx={uiFieldStyles}>
            <Select
              value={getClassData("10").grading || ""}
              displayEmpty
              onChange={(e) => setClassData("10", { grading: e.target.value })}
            >
              <MenuItem value="" disabled>
                Choose option
              </MenuItem>
              {gradingOptions.map((g) => (
                <MenuItem key={g} value={g}>
                  {g}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid> */}
            <FormControlLabel
              sx={{ pl: 4 }}
              control={
                <Checkbox
                  checked={sameSubjects}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    setSameSubjects(checked);

                    if (checked) {
                      setClassData("10", {
                        subjects: [...(getClassData("9").subjects || [])],
                        marks: {}, // reset marks
                      });
                    } else {
                      setClassData("10", {
                        subjects: [],
                        marks: {},
                      });
                    }
                  }}
                />
              }
              label="Same subjects as Class 9th"
            />

            {/* Subjects */}
            <Grid item xs={12}>
              <Typography sx={{ mb: 2, fontWeight: 600 }}>Subjects*</Typography>
              <Box sx={{ background: "white", p: 2, borderRadius: "10px" }}>
                {subjectsList.map((subject) => (
                  <FormControlLabel
                    key={subject}
                    control={
                      <Checkbox
                        disabled={sameSubjects}
                        checked={(getClassData("10").subjects || []).includes(
                          subject,
                        )}
                        onChange={() => toggleSubject("10", subject)}
                      />
                    }
                    label={subject}
                  />
                ))}
              </Box>
            </Grid>
            {errors.class10_subjects && (
              <Typography sx={{ color: "#d32f2f", mt: 1 }}>
                {errors.class10_subjects}
              </Typography>
            )}

            {/* Marks */}
            {subjectsList
              .filter((s) => getClassData("10").subjects?.includes(s))
              .map((subject) => (
                <Grid item xs={12} key={subject}>
                  <Typography sx={{ mb: 1, fontWeight: 600 }}>
                    Select Marks for {subject} (Class 10)
                  </Typography>

                  <RadioGroup
                    value={getClassData("10").marks?.[subject] || ""}
                    onChange={(e) =>
                      handleMarksChange("10", subject, e.target.value)
                    }
                  >
                    {getMarksOptions().map((m) => (
                      <FormControlLabel
                        key={m}
                        value={m}
                        control={<Radio />}
                        label={m}
                      />
                    ))}
                  </RadioGroup>
                </Grid>
              ))}
            <Button
              variant="contained"
              sx={{ mt: 4, ml: 3 }}
              onClick={() => {
                // Optional: validate only Class 9 here
                setShowClass10(false);
              }}
            >
              Back to Class 9th
            </Button>
            {errors.class10_marks && (
              <Typography sx={{ color: "#d32f2f", mt: 1 }}>
                {errors.class10_marks}
              </Typography>
            )}
          </Grid>

          {/* Buttons */}
          <Grid
            item
            xs={12}
            mt={5}
            display="flex"
            gap={2}
            justifyContent="space-between"
            alignItems="center"
          >
            <Button
              variant="outlined"
              disabled={isSubmitting}
              onClick={() => {
                checkCategory();
              }}
              sx={{
                borderColor: "#2C2C2C",
                color: "#2C2C2C",
                padding: "6px 28px",
              }}
            >
              {isSubmitting ? "Loading..." : "Back"}
            </Button>

            <Button
              variant="contained"
              onClick={() => handleNextClick(data)}
              sx={{
                backgroundColor: "#2C2C2C",
                color: "white",
                padding: "6px 28px",
                borderRadius: "6px",
                "&:hover": { backgroundColor: "#444" },
              }}
            >
              Next
            </Button>
          </Grid>
        </>
      )}

      {/* </Grid> */}
    </Box>
  );
};

export default SchoolingStep910;
